// MAE : seul le périmètre CLASSIQUE est exploité (AUTOP, RGA, -500,
// AfriqueAssistance et BRIS_DE_GLACE ne sont pas gérés par le client)
export const ManagementTypes= [ 
    { label: "CLASSIQUE" },
  ]
